import { Injectable } from '@angular/core';
import { gql, Mutation } from 'apollo-angular';

import { Mutation as RootMutation } from 'graphql/models/generated';

export const SET_ACCOUNT_PREFERENCE_MUTATION = gql`
  mutation setAccountPreference(
    $data: AccountPreferencesCreateInput!
  ) {
    setAccountPreference(data: $data) {
      id
      type
      accountId
      key
      name
      value
    }
  }
`;

@Injectable({ providedIn: 'root' })
export class SetAccountPreferenceMutation extends Mutation<RootMutation> {
  document = SET_ACCOUNT_PREFERENCE_MUTATION;
}
